export const blankDataModelSchemaVersion = '0.0.1';
export const blankDataModel: Record<string, any> = {
  isPreciseDestination: true, // Required: True assumes precise unless specified
  isInternational: false, // Required: False assumes domestic travel
  isBringingPets: false, // Required: False unless user specifies pets for this trip
  isBringingChildren: false, // Required: False unless user specifies children for this trip
  seatsNeeded: null, // Optional: Seats needed if no existing reservation
  isValid: false, // Required: False until all required fields are populated
  arrivalData: {
    preciseDestination: {
      locationName: null, // Required if isPreciseDestination true (e.g., "Dallas, TX, US")
      airportName: null, // Required if isPreciseDestination true (e.g., "Dallas Love Field")
      airportCode: null, // Required if isPreciseDestination true (e.g., "DAL")
      state: null,     // e.g., "FL"
      country: null,   // e.g., "US"
      destinationType: null,     // e.g., "Beach", "Mountain"
    },
    generalDestination: {
      destinationType: null, // Required if isPreciseDestination false (e.g., "Beach" || "Mountain" || "Other")
      country: null, // Optional: General country (e.g., "US")
      state: null, // Optional: General state (e.g., "CA")
    },
  },
  departureData: {
    locationName: null, // Required: User’s starting point (e.g., "Dallas, TX, US")
    airportName: null, // Required: Departure airport (e.g., "Dallas Love Field")
    airportCode: null, // Required: IATA code (e.g., "DAL")
  },
  travelTiming: {
    timeZone: '', // Required: From departure or userProfile (e.g., "America/Chicago")
    departureDateExact: null, // Optional: ISO 8601 (e.g., "2025-03-25") for specific day
    departureDateRange: {
      start: null, // Optional: ISO 8601 (e.g., "2025-03-25") for range start
      end: null, // Optional: ISO 8601 (e.g., "2025-03-28") for range end
    },
    departureTimeExact: null, // Optional: ISO 8601 (e.g., "09:00:00-05:00") for exact time
    departureTimeRange: {
      start: null, // Optional: ISO 8601 (e.g., "06:00:00-05:00") for range start
      end: null, // Optional: ISO 8601 (e.g., "12:00:00-05:00") for range end
    },
    estimatedFlightHours: null,
  },
  userData: {
    preferences: {
      isQuietFlightOnly: false, // Required: False unless specified or from profile
      isPetOk: true, // Required: True unless specified or from profile (willingness to allow)
      isChildrenOk: true, // Required: True unless specified or from profile (willingness to allow)
    },
    membership: {
      organization: '', // Required: From profile (e.g., "NetJets")
      aircraftTier: null, // Required: From profile
      aircraft: '', // Required: From profile (e.g., "Citation X")
      aircraftMaxSeats: null, // Optional: Max seats (e.g., 8)
    },
  },
  reservationData: {
    isExistingReservation: false, // Required: False unless specified
    expectedMood: null, // Optional: Mood for existing flight
    seatsOffered: null, // Optional: Seats available in existing reservation
  },
  userFlightOptionId: null,
};
